// @generated by protobuf-ts 2.11.1 with parameter long_type_string,generate_dependencies,output_legacy_commonjs
// @generated from protobuf file "sennotech/base/organization/organization.proto" (package "base.organization", syntax proto3)
// tslint:disable
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { OrganizationService } from "./organization";
import type { GetPresignedPutObjectUrlResponse } from "./organization";
import type { GetPresignedPutObjectUrlRequest } from "./organization";
import type { GetDefaultOrganizationRelationshipResponse } from "./organization";
import type { GetDefaultOrganizationRelationshipRequest } from "./organization";
import type { GetOrganizationRelationshipListByOrganizationIdResponse } from "./organization";
import type { GetOrganizationRelationshipListByOrganizationIdRequest } from "./organization";
import type { GetOrganizationRelationshipByIdResponse } from "./organization";
import type { GetOrganizationRelationshipByIdRequest } from "./organization";
import type { AlterDefaultOrganizationRelationshipResponse } from "./organization";
import type { AlterDefaultOrganizationRelationshipRequest } from "./organization";
import type { DeleteOrganizationRelationshipResponse } from "./organization";
import type { DeleteOrganizationRelationshipRequest } from "./organization";
import type { CreateOrganizationRelationshipResponse } from "./organization";
import type { CreateOrganizationRelationshipRequest } from "./organization";
import type { GetAccountGroupPermissionUUIDsResponse } from "./organization";
import type { GetAccountGroupPermissionUUIDsRequest } from "./organization";
import type { DeleteAccountGroupPermissionResponse } from "./organization";
import type { DeleteAccountGroupPermissionRequest } from "./organization";
import type { ListAccountGroupPermissionUUIDResponse } from "./organization";
import type { ListAccountGroupPermissionUUIDRequest } from "./organization";
import type { ListAccountGroupPermissionResponse } from "./organization";
import type { ListAccountGroupPermissionRequest } from "./organization";
import type { AuthorizeToAccountGroupResponse } from "./organization";
import type { AuthorizeToAccountGroupRequest } from "./organization";
import type { GetAccountPermissionResponse } from "./organization";
import type { GetAccountPermissionRequest } from "./organization";
import type { AcceptUserInvitationResponse } from "./organization";
import type { AcceptUserInvitationRequest } from "./organization";
import type { GetUserGroupInvitationUuidResponse } from "./organization";
import type { GetUserGroupInvitationUuidRequest } from "./organization";
import type { GetAccountGroupContextResponse } from "./organization";
import type { GetAccountGroupContextRequest } from "./organization";
import type { RemoveAccountFromAccountGroupResponse } from "./organization";
import type { RemoveAccountFromAccountGroupRequest } from "./organization";
import type { GetAccountGroupAccountResponse } from "./organization";
import type { GetAccountGroupAccountRequest } from "./organization";
import type { DeletedAccountGroupResponse } from "./organization";
import type { DeletedAccountGroupRequest } from "./organization";
import type { GetAccountGroupByAccountIdResponse } from "./organization";
import type { GetAccountGroupByAccountIdRequest } from "./organization";
import type { AddAccountToAccountGroupResponse } from "./organization";
import type { AddAccountToAccountGroupRequest } from "./organization";
import type { AddAccountToAccountGroupByAccountIdResponse } from "./organization";
import type { AddAccountToAccountGroupByAccountIdRequest } from "./organization";
import type { GetAccountGroupResponse } from "./organization";
import type { GetAccountGroupRequest } from "./organization";
import type { UpdateAccountGroupResponse } from "./organization";
import type { UpdateAccountGroupRequest } from "./organization";
import type { CreateAccountGroupResponse } from "./organization";
import type { CreateAccountGroupRequest } from "./organization";
import type { ListOrganizationsResponse } from "./organization";
import type { ListOrganizationsRequest } from "./organization";
import type { ListOrganizationByAccountIdResponse } from "./organization";
import type { ListOrganizationByAccountIdRequest } from "./organization";
import type { GetOrganizationContextResponse } from "./organization";
import type { GetOrganizationContextRequest } from "./organization";
import type { DeleteOrganizationResponse } from "./organization";
import type { DeleteOrganizationRequest } from "./organization";
import type { ListAccountsByOrganizationIdsAndAccountGroupNameResponse } from "./organization";
import type { ListAccountsByOrganizationIdsAndAccountGroupNameRequest } from "./organization";
import type { PageListAccountGroupAccountsResponse } from "./organization";
import type { PageListAccountGroupAccountsRequest } from "./organization";
import type { NewGetAccountGroupAccountsByOrganizationIdsResponse } from "./organization";
import type { NewGetAccountGroupAccountsByOrganizationIdsRequest } from "./organization";
import type { GetAccountGroupAccountsByOrganizationIdsResponse } from "./organization";
import type { GetAccountGroupAccountsByOrganizationIdsRequest } from "./organization";
import type { GetAccountByOrganizationIdResponse } from "./organization";
import type { GetAccountByOrganizationIdRequest } from "./organization";
import type { GetOrganizationByNameAndTypeResponse } from "./organization";
import type { GetOrganizationByNameAndTypeRequest } from "./organization";
import type { UpdateOrganizationGroupNameAndDescriptionResponse } from "./organization";
import type { UpdateOrganizationGroupNameAndDescriptionRequest } from "./organization";
import type { UpdateOrganizationNameAndDescriptionResponse } from "./organization";
import type { UpdateOrganizationNameAndDescriptionRequest } from "./organization";
import type { GetOrganizationsByTypeResponse } from "./organization";
import type { GetOrganizationsByTypeRequest } from "./organization";
import type { GetOrganizationByIdsResponse } from "./organization";
import type { GetOrganizationByIdsRequest } from "./organization";
import type { GetOrganizationByOrganizationGroupIdResponse } from "./organization";
import type { GetOrganizationByOrganizationGroupIdRequest } from "./organization";
import type { GetOrganizationOrganizationsResponse } from "./organization";
import type { GetOrganizationOrganizationsRequest } from "./organization";
import type { GetOrganizationParentOrganizationGroupResponse } from "./organization";
import type { GetOrganizationParentOrganizationGroupRequest } from "./organization";
import type { UpdateOrganizationsOrganizationGroupResponse } from "./organization";
import type { UpdateOrganizationsOrganizationGroupRequest } from "./organization";
import type { PageListOrganizationsResponse } from "./organization";
import type { PageListOrganizationsRequest } from "./organization";
import type { GetOrganizationsByOrganizationGroupIdsResponse } from "./organization";
import type { GetOrganizationsByOrganizationGroupIdsRequest } from "./organization";
import type { GetOrganizationGroupsByOrganizationIdResponse } from "./organization";
import type { GetOrganizationGroupsByOrganizationIdRequest } from "./organization";
import type { CheckOrganizationResponse } from "./organization";
import type { CheckOrganizationRequest } from "./organization";
import type { CreateOrganizationResponse } from "./organization";
import type { CreateOrganizationRequest } from "./organization";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { CreateOrganizationGroupResponse } from "./organization";
import type { CreateOrganizationGroupRequest } from "./organization";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * 组织关系
 *
 * @generated from protobuf service base.organization.OrganizationService
 */
export interface IOrganizationServiceClient {
    /**
     * region organization
     * 创建「组织组」
     *
     * @generated from protobuf rpc: CreateOrganizationGroup
     */
    createOrganizationGroup(input: CreateOrganizationGroupRequest, options?: RpcOptions): UnaryCall<CreateOrganizationGroupRequest, CreateOrganizationGroupResponse>;
    /**
     * 创建「组织」
     *
     * @generated from protobuf rpc: CreateOrganization
     */
    createOrganization(input: CreateOrganizationRequest, options?: RpcOptions): UnaryCall<CreateOrganizationRequest, CreateOrganizationResponse>;
    /**
     * 确认「组织」是否存在
     *
     * @generated from protobuf rpc: CheckOrganization
     */
    checkOrganization(input: CheckOrganizationRequest, options?: RpcOptions): UnaryCall<CheckOrganizationRequest, CheckOrganizationResponse>;
    /**
     * 查看「组织」下的所有「组织组」
     *
     * @generated from protobuf rpc: GetOrganizationGroupsByOrganizationId
     */
    getOrganizationGroupsByOrganizationId(input: GetOrganizationGroupsByOrganizationIdRequest, options?: RpcOptions): UnaryCall<GetOrganizationGroupsByOrganizationIdRequest, GetOrganizationGroupsByOrganizationIdResponse>;
    /**
     * 查看「组织组」下的所有「组织」
     *
     * @generated from protobuf rpc: GetOrganizationsByOrganizationGroupIds
     */
    getOrganizationsByOrganizationGroupIds(input: GetOrganizationsByOrganizationGroupIdsRequest, options?: RpcOptions): UnaryCall<GetOrganizationsByOrganizationGroupIdsRequest, GetOrganizationsByOrganizationGroupIdsResponse>;
    /**
     * 分页查看「组织组」下的所有「组织」
     *
     * @generated from protobuf rpc: PageListOrganizations
     */
    pageListOrganizations(input: PageListOrganizationsRequest, options?: RpcOptions): UnaryCall<PageListOrganizationsRequest, PageListOrganizationsResponse>;
    /**
     * 修改「组织」的「组织组」
     *
     * @generated from protobuf rpc: UpdateOrganizationsOrganizationGroup
     */
    updateOrganizationsOrganizationGroup(input: UpdateOrganizationsOrganizationGroupRequest, options?: RpcOptions): UnaryCall<UpdateOrganizationsOrganizationGroupRequest, UpdateOrganizationsOrganizationGroupResponse>;
    /**
     * 查看「组织」所属「组织组」
     *
     * @generated from protobuf rpc: GetOrganizationParentOrganizationGroup
     */
    getOrganizationParentOrganizationGroup(input: GetOrganizationParentOrganizationGroupRequest, options?: RpcOptions): UnaryCall<GetOrganizationParentOrganizationGroupRequest, GetOrganizationParentOrganizationGroupResponse>;
    /**
     * 查看「组织」下的所有「组织」
     *
     * @generated from protobuf rpc: GetOrganizationOrganizations
     */
    getOrganizationOrganizations(input: GetOrganizationOrganizationsRequest, options?: RpcOptions): UnaryCall<GetOrganizationOrganizationsRequest, GetOrganizationOrganizationsResponse>;
    /**
     * 查看「组织组」的「组织」信息
     *
     * @generated from protobuf rpc: GetOrganizationByOrganizationGroupId
     */
    getOrganizationByOrganizationGroupId(input: GetOrganizationByOrganizationGroupIdRequest, options?: RpcOptions): UnaryCall<GetOrganizationByOrganizationGroupIdRequest, GetOrganizationByOrganizationGroupIdResponse>;
    /**
     * 批量根据「组织」id列表查看「组织」
     *
     * @generated from protobuf rpc: GetOrganizationByIds
     */
    getOrganizationByIds(input: GetOrganizationByIdsRequest, options?: RpcOptions): UnaryCall<GetOrganizationByIdsRequest, GetOrganizationByIdsResponse>;
    /**
     * 根据类型查看「组织」
     *
     * @generated from protobuf rpc: GetOrganizationsByType
     */
    getOrganizationsByType(input: GetOrganizationsByTypeRequest, options?: RpcOptions): UnaryCall<GetOrganizationsByTypeRequest, GetOrganizationsByTypeResponse>;
    /**
     * 修改「组织」名与描述
     *
     * @generated from protobuf rpc: UpdateOrganizationNameAndDescription
     */
    updateOrganizationNameAndDescription(input: UpdateOrganizationNameAndDescriptionRequest, options?: RpcOptions): UnaryCall<UpdateOrganizationNameAndDescriptionRequest, UpdateOrganizationNameAndDescriptionResponse>;
    /**
     * 修改「组织组」名与描述
     *
     * @generated from protobuf rpc: UpdateOrganizationGroupNameAndDescription
     */
    updateOrganizationGroupNameAndDescription(input: UpdateOrganizationGroupNameAndDescriptionRequest, options?: RpcOptions): UnaryCall<UpdateOrganizationGroupNameAndDescriptionRequest, UpdateOrganizationGroupNameAndDescriptionResponse>;
    /**
     * 根据名称和类型获取「组织」
     *
     * @generated from protobuf rpc: GetOrganizationByNameAndType
     */
    getOrganizationByNameAndType(input: GetOrganizationByNameAndTypeRequest, options?: RpcOptions): UnaryCall<GetOrganizationByNameAndTypeRequest, GetOrganizationByNameAndTypeResponse>;
    /**
     * 获取「组织」下的第一个「用户组」下的第一个「用户」
     *
     * @generated from protobuf rpc: GetAccountByOrganizationId
     */
    getAccountByOrganizationId(input: GetAccountByOrganizationIdRequest, options?: RpcOptions): UnaryCall<GetAccountByOrganizationIdRequest, GetAccountByOrganizationIdResponse>;
    /**
     * 批量获取「组织」下的所有「用户」，返回accountID集合
     *
     * @generated from protobuf rpc: GetAccountGroupAccountsByOrganizationIds
     */
    getAccountGroupAccountsByOrganizationIds(input: GetAccountGroupAccountsByOrganizationIdsRequest, options?: RpcOptions): UnaryCall<GetAccountGroupAccountsByOrganizationIdsRequest, GetAccountGroupAccountsByOrganizationIdsResponse>;
    /**
     * 新 获取「组织」下的所有「用户」，返回「organizationID、accountID」集合
     *
     * @generated from protobuf rpc: NewGetAccountGroupAccountsByOrganizationIds
     */
    newGetAccountGroupAccountsByOrganizationIds(input: NewGetAccountGroupAccountsByOrganizationIdsRequest, options?: RpcOptions): UnaryCall<NewGetAccountGroupAccountsByOrganizationIdsRequest, NewGetAccountGroupAccountsByOrganizationIdsResponse>;
    /**
     * 分页获取 获取「组织」下的所有「用户」，返回「organizationID、accountID」集合
     *
     * @generated from protobuf rpc: PageListAccountGroupAccounts
     */
    pageListAccountGroupAccounts(input: PageListAccountGroupAccountsRequest, options?: RpcOptions): UnaryCall<PageListAccountGroupAccountsRequest, PageListAccountGroupAccountsResponse>;
    /**
     * 批量获取指定用户组成员根据「组织列表、用户组名」
     *
     * @generated from protobuf rpc: ListAccountsByOrganizationIdsAndAccountGroupName
     */
    listAccountsByOrganizationIdsAndAccountGroupName(input: ListAccountsByOrganizationIdsAndAccountGroupNameRequest, options?: RpcOptions): UnaryCall<ListAccountsByOrganizationIdsAndAccountGroupNameRequest, ListAccountsByOrganizationIdsAndAccountGroupNameResponse>;
    /**
     * 删除组织
     *
     * @generated from protobuf rpc: DeleteOrganization
     */
    deleteOrganization(input: DeleteOrganizationRequest, options?: RpcOptions): UnaryCall<DeleteOrganizationRequest, DeleteOrganizationResponse>;
    /**
     * 根据组织类型获取OrganizationContext
     *
     * @generated from protobuf rpc: GetOrganizationContext
     */
    getOrganizationContext(input: GetOrganizationContextRequest, options?: RpcOptions): UnaryCall<GetOrganizationContextRequest, GetOrganizationContextResponse>;
    /**
     * 查看accountId所在的组织（若不传accountID，则从access token中获取）
     *
     * @generated from protobuf rpc: ListOrganizationByAccountId
     */
    listOrganizationByAccountId(input: ListOrganizationByAccountIdRequest, options?: RpcOptions): UnaryCall<ListOrganizationByAccountIdRequest, ListOrganizationByAccountIdResponse>;
    /**
     * @generated from protobuf rpc: ListOrganizations
     */
    listOrganizations(input: ListOrganizationsRequest, options?: RpcOptions): UnaryCall<ListOrganizationsRequest, ListOrganizationsResponse>;
    /**
     * region account group
     * 创建用户组
     *
     * @generated from protobuf rpc: CreateAccountGroup
     */
    createAccountGroup(input: CreateAccountGroupRequest, options?: RpcOptions): UnaryCall<CreateAccountGroupRequest, CreateAccountGroupResponse>;
    /**
     * @generated from protobuf rpc: UpdateAccountGroup
     */
    updateAccountGroup(input: UpdateAccountGroupRequest, options?: RpcOptions): UnaryCall<UpdateAccountGroupRequest, UpdateAccountGroupResponse>;
    /**
     * 获取用户组
     *
     * @generated from protobuf rpc: GetAccountGroup
     */
    getAccountGroup(input: GetAccountGroupRequest, options?: RpcOptions): UnaryCall<GetAccountGroupRequest, GetAccountGroupResponse>;
    /**
     * 组织组新增用户（根据accountID）
     *
     * @generated from protobuf rpc: AddAccountToAccountGroupByAccountId
     */
    addAccountToAccountGroupByAccountId(input: AddAccountToAccountGroupByAccountIdRequest, options?: RpcOptions): UnaryCall<AddAccountToAccountGroupByAccountIdRequest, AddAccountToAccountGroupByAccountIdResponse>;
    /**
     * 用户自己加入用户组（用户登陆后传accessToken）
     *
     * @generated from protobuf rpc: AddAccountToAccountGroup
     */
    addAccountToAccountGroup(input: AddAccountToAccountGroupRequest, options?: RpcOptions): UnaryCall<AddAccountToAccountGroupRequest, AddAccountToAccountGroupResponse>;
    /**
     * 获取「用户」的「用户组」
     *
     * @generated from protobuf rpc: GetAccountGroupByAccountId
     */
    getAccountGroupByAccountId(input: GetAccountGroupByAccountIdRequest, options?: RpcOptions): UnaryCall<GetAccountGroupByAccountIdRequest, GetAccountGroupByAccountIdResponse>;
    /**
     * 删除用户组
     *
     * @generated from protobuf rpc: DeletedAccountGroup
     */
    deletedAccountGroup(input: DeletedAccountGroupRequest, options?: RpcOptions): UnaryCall<DeletedAccountGroupRequest, DeletedAccountGroupResponse>;
    /**
     * 获取用户组成员
     *
     * @generated from protobuf rpc: GetAccountGroupAccount
     */
    getAccountGroupAccount(input: GetAccountGroupAccountRequest, options?: RpcOptions): UnaryCall<GetAccountGroupAccountRequest, GetAccountGroupAccountResponse>;
    /**
     * 用户组织移除用户
     *
     * @generated from protobuf rpc: RemoveAccountFromAccountGroup
     */
    removeAccountFromAccountGroup(input: RemoveAccountFromAccountGroupRequest, options?: RpcOptions): UnaryCall<RemoveAccountFromAccountGroupRequest, RemoveAccountFromAccountGroupResponse>;
    /**
     * @generated from protobuf rpc: GetAccountGroupContext
     */
    getAccountGroupContext(input: GetAccountGroupContextRequest, options?: RpcOptions): UnaryCall<GetAccountGroupContextRequest, GetAccountGroupContextResponse>;
    /**
     * 获取添加用户uuid
     *
     * @generated from protobuf rpc: GetUserGroupInvitationUuid
     */
    getUserGroupInvitationUuid(input: GetUserGroupInvitationUuidRequest, options?: RpcOptions): UnaryCall<GetUserGroupInvitationUuidRequest, GetUserGroupInvitationUuidResponse>;
    /**
     * 用户组添加用户（uuid）
     *
     * @generated from protobuf rpc: AcceptUserInvitation
     */
    acceptUserInvitation(input: AcceptUserInvitationRequest, options?: RpcOptions): UnaryCall<AcceptUserInvitationRequest, AcceptUserInvitationResponse>;
    /**
     * region permission
     *
     * @generated from protobuf rpc: GetAccountPermission
     */
    getAccountPermission(input: GetAccountPermissionRequest, options?: RpcOptions): UnaryCall<GetAccountPermissionRequest, GetAccountPermissionResponse>;
    /**
     * 给用户组授权
     *
     * @generated from protobuf rpc: AuthorizeToAccountGroup
     */
    authorizeToAccountGroup(input: AuthorizeToAccountGroupRequest, options?: RpcOptions): UnaryCall<AuthorizeToAccountGroupRequest, AuthorizeToAccountGroupResponse>;
    /**
     * 获取用户组权限
     *
     * @generated from protobuf rpc: ListAccountGroupPermission
     */
    listAccountGroupPermission(input: ListAccountGroupPermissionRequest, options?: RpcOptions): UnaryCall<ListAccountGroupPermissionRequest, ListAccountGroupPermissionResponse>;
    /**
     * 获取组织用户组权限UUIDs（鉴权用）
     *
     * @generated from protobuf rpc: ListAccountGroupPermissionUUID
     */
    listAccountGroupPermissionUUID(input: ListAccountGroupPermissionUUIDRequest, options?: RpcOptions): UnaryCall<ListAccountGroupPermissionUUIDRequest, ListAccountGroupPermissionUUIDResponse>;
    /**
     * 删除组织用户组权限
     *
     * @generated from protobuf rpc: DeleteAccountGroupPermission
     */
    deleteAccountGroupPermission(input: DeleteAccountGroupPermissionRequest, options?: RpcOptions): UnaryCall<DeleteAccountGroupPermissionRequest, DeleteAccountGroupPermissionResponse>;
    /**
     * 根据用户组id获取权限uuid集合
     *
     * @generated from protobuf rpc: GetAccountGroupPermissionUUIDs
     */
    getAccountGroupPermissionUUIDs(input: GetAccountGroupPermissionUUIDsRequest, options?: RpcOptions): UnaryCall<GetAccountGroupPermissionUUIDsRequest, GetAccountGroupPermissionUUIDsResponse>;
    /**
     * region organization relationship
     * 创建组织关系
     *
     * @generated from protobuf rpc: CreateOrganizationRelationship
     */
    createOrganizationRelationship(input: CreateOrganizationRelationshipRequest, options?: RpcOptions): UnaryCall<CreateOrganizationRelationshipRequest, CreateOrganizationRelationshipResponse>;
    /**
     * 删除组织关系
     *
     * @generated from protobuf rpc: DeleteOrganizationRelationship
     */
    deleteOrganizationRelationship(input: DeleteOrganizationRelationshipRequest, options?: RpcOptions): UnaryCall<DeleteOrganizationRelationshipRequest, DeleteOrganizationRelationshipResponse>;
    /**
     * 切换默认组织关系
     *
     * @generated from protobuf rpc: AlterDefaultOrganizationRelationship
     */
    alterDefaultOrganizationRelationship(input: AlterDefaultOrganizationRelationshipRequest, options?: RpcOptions): UnaryCall<AlterDefaultOrganizationRelationshipRequest, AlterDefaultOrganizationRelationshipResponse>;
    /**
     * 通过id获取组织关系
     *
     * @generated from protobuf rpc: GetOrganizationRelationshipById
     */
    getOrganizationRelationshipById(input: GetOrganizationRelationshipByIdRequest, options?: RpcOptions): UnaryCall<GetOrganizationRelationshipByIdRequest, GetOrganizationRelationshipByIdResponse>;
    /**
     * 通过organizationId获取组织关系列表
     *
     * @generated from protobuf rpc: GetOrganizationRelationshipListByOrganizationId
     */
    getOrganizationRelationshipListByOrganizationId(input: GetOrganizationRelationshipListByOrganizationIdRequest, options?: RpcOptions): UnaryCall<GetOrganizationRelationshipListByOrganizationIdRequest, GetOrganizationRelationshipListByOrganizationIdResponse>;
    /**
     * 通过organizationId获取默认组织关系
     *
     * @generated from protobuf rpc: GetDefaultOrganizationRelationship
     */
    getDefaultOrganizationRelationship(input: GetDefaultOrganizationRelationshipRequest, options?: RpcOptions): UnaryCall<GetDefaultOrganizationRelationshipRequest, GetDefaultOrganizationRelationshipResponse>;
    /**
     * 获取上传组织logo的预签名链接
     *
     * @generated from protobuf rpc: GetPresignedPutObjectUrl
     */
    getPresignedPutObjectUrl(input: GetPresignedPutObjectUrlRequest, options?: RpcOptions): UnaryCall<GetPresignedPutObjectUrlRequest, GetPresignedPutObjectUrlResponse>;
}
/**
 * 组织关系
 *
 * @generated from protobuf service base.organization.OrganizationService
 */
export class OrganizationServiceClient implements IOrganizationServiceClient, ServiceInfo {
    typeName = OrganizationService.typeName;
    methods = OrganizationService.methods;
    options = OrganizationService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * region organization
     * 创建「组织组」
     *
     * @generated from protobuf rpc: CreateOrganizationGroup
     */
    createOrganizationGroup(input: CreateOrganizationGroupRequest, options?: RpcOptions): UnaryCall<CreateOrganizationGroupRequest, CreateOrganizationGroupResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateOrganizationGroupRequest, CreateOrganizationGroupResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 创建「组织」
     *
     * @generated from protobuf rpc: CreateOrganization
     */
    createOrganization(input: CreateOrganizationRequest, options?: RpcOptions): UnaryCall<CreateOrganizationRequest, CreateOrganizationResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateOrganizationRequest, CreateOrganizationResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 确认「组织」是否存在
     *
     * @generated from protobuf rpc: CheckOrganization
     */
    checkOrganization(input: CheckOrganizationRequest, options?: RpcOptions): UnaryCall<CheckOrganizationRequest, CheckOrganizationResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<CheckOrganizationRequest, CheckOrganizationResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 查看「组织」下的所有「组织组」
     *
     * @generated from protobuf rpc: GetOrganizationGroupsByOrganizationId
     */
    getOrganizationGroupsByOrganizationId(input: GetOrganizationGroupsByOrganizationIdRequest, options?: RpcOptions): UnaryCall<GetOrganizationGroupsByOrganizationIdRequest, GetOrganizationGroupsByOrganizationIdResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetOrganizationGroupsByOrganizationIdRequest, GetOrganizationGroupsByOrganizationIdResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 查看「组织组」下的所有「组织」
     *
     * @generated from protobuf rpc: GetOrganizationsByOrganizationGroupIds
     */
    getOrganizationsByOrganizationGroupIds(input: GetOrganizationsByOrganizationGroupIdsRequest, options?: RpcOptions): UnaryCall<GetOrganizationsByOrganizationGroupIdsRequest, GetOrganizationsByOrganizationGroupIdsResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetOrganizationsByOrganizationGroupIdsRequest, GetOrganizationsByOrganizationGroupIdsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 分页查看「组织组」下的所有「组织」
     *
     * @generated from protobuf rpc: PageListOrganizations
     */
    pageListOrganizations(input: PageListOrganizationsRequest, options?: RpcOptions): UnaryCall<PageListOrganizationsRequest, PageListOrganizationsResponse> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<PageListOrganizationsRequest, PageListOrganizationsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 修改「组织」的「组织组」
     *
     * @generated from protobuf rpc: UpdateOrganizationsOrganizationGroup
     */
    updateOrganizationsOrganizationGroup(input: UpdateOrganizationsOrganizationGroupRequest, options?: RpcOptions): UnaryCall<UpdateOrganizationsOrganizationGroupRequest, UpdateOrganizationsOrganizationGroupResponse> {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateOrganizationsOrganizationGroupRequest, UpdateOrganizationsOrganizationGroupResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 查看「组织」所属「组织组」
     *
     * @generated from protobuf rpc: GetOrganizationParentOrganizationGroup
     */
    getOrganizationParentOrganizationGroup(input: GetOrganizationParentOrganizationGroupRequest, options?: RpcOptions): UnaryCall<GetOrganizationParentOrganizationGroupRequest, GetOrganizationParentOrganizationGroupResponse> {
        const method = this.methods[7], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetOrganizationParentOrganizationGroupRequest, GetOrganizationParentOrganizationGroupResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 查看「组织」下的所有「组织」
     *
     * @generated from protobuf rpc: GetOrganizationOrganizations
     */
    getOrganizationOrganizations(input: GetOrganizationOrganizationsRequest, options?: RpcOptions): UnaryCall<GetOrganizationOrganizationsRequest, GetOrganizationOrganizationsResponse> {
        const method = this.methods[8], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetOrganizationOrganizationsRequest, GetOrganizationOrganizationsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 查看「组织组」的「组织」信息
     *
     * @generated from protobuf rpc: GetOrganizationByOrganizationGroupId
     */
    getOrganizationByOrganizationGroupId(input: GetOrganizationByOrganizationGroupIdRequest, options?: RpcOptions): UnaryCall<GetOrganizationByOrganizationGroupIdRequest, GetOrganizationByOrganizationGroupIdResponse> {
        const method = this.methods[9], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetOrganizationByOrganizationGroupIdRequest, GetOrganizationByOrganizationGroupIdResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 批量根据「组织」id列表查看「组织」
     *
     * @generated from protobuf rpc: GetOrganizationByIds
     */
    getOrganizationByIds(input: GetOrganizationByIdsRequest, options?: RpcOptions): UnaryCall<GetOrganizationByIdsRequest, GetOrganizationByIdsResponse> {
        const method = this.methods[10], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetOrganizationByIdsRequest, GetOrganizationByIdsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 根据类型查看「组织」
     *
     * @generated from protobuf rpc: GetOrganizationsByType
     */
    getOrganizationsByType(input: GetOrganizationsByTypeRequest, options?: RpcOptions): UnaryCall<GetOrganizationsByTypeRequest, GetOrganizationsByTypeResponse> {
        const method = this.methods[11], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetOrganizationsByTypeRequest, GetOrganizationsByTypeResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 修改「组织」名与描述
     *
     * @generated from protobuf rpc: UpdateOrganizationNameAndDescription
     */
    updateOrganizationNameAndDescription(input: UpdateOrganizationNameAndDescriptionRequest, options?: RpcOptions): UnaryCall<UpdateOrganizationNameAndDescriptionRequest, UpdateOrganizationNameAndDescriptionResponse> {
        const method = this.methods[12], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateOrganizationNameAndDescriptionRequest, UpdateOrganizationNameAndDescriptionResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 修改「组织组」名与描述
     *
     * @generated from protobuf rpc: UpdateOrganizationGroupNameAndDescription
     */
    updateOrganizationGroupNameAndDescription(input: UpdateOrganizationGroupNameAndDescriptionRequest, options?: RpcOptions): UnaryCall<UpdateOrganizationGroupNameAndDescriptionRequest, UpdateOrganizationGroupNameAndDescriptionResponse> {
        const method = this.methods[13], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateOrganizationGroupNameAndDescriptionRequest, UpdateOrganizationGroupNameAndDescriptionResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 根据名称和类型获取「组织」
     *
     * @generated from protobuf rpc: GetOrganizationByNameAndType
     */
    getOrganizationByNameAndType(input: GetOrganizationByNameAndTypeRequest, options?: RpcOptions): UnaryCall<GetOrganizationByNameAndTypeRequest, GetOrganizationByNameAndTypeResponse> {
        const method = this.methods[14], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetOrganizationByNameAndTypeRequest, GetOrganizationByNameAndTypeResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 获取「组织」下的第一个「用户组」下的第一个「用户」
     *
     * @generated from protobuf rpc: GetAccountByOrganizationId
     */
    getAccountByOrganizationId(input: GetAccountByOrganizationIdRequest, options?: RpcOptions): UnaryCall<GetAccountByOrganizationIdRequest, GetAccountByOrganizationIdResponse> {
        const method = this.methods[15], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetAccountByOrganizationIdRequest, GetAccountByOrganizationIdResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 批量获取「组织」下的所有「用户」，返回accountID集合
     *
     * @generated from protobuf rpc: GetAccountGroupAccountsByOrganizationIds
     */
    getAccountGroupAccountsByOrganizationIds(input: GetAccountGroupAccountsByOrganizationIdsRequest, options?: RpcOptions): UnaryCall<GetAccountGroupAccountsByOrganizationIdsRequest, GetAccountGroupAccountsByOrganizationIdsResponse> {
        const method = this.methods[16], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetAccountGroupAccountsByOrganizationIdsRequest, GetAccountGroupAccountsByOrganizationIdsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 新 获取「组织」下的所有「用户」，返回「organizationID、accountID」集合
     *
     * @generated from protobuf rpc: NewGetAccountGroupAccountsByOrganizationIds
     */
    newGetAccountGroupAccountsByOrganizationIds(input: NewGetAccountGroupAccountsByOrganizationIdsRequest, options?: RpcOptions): UnaryCall<NewGetAccountGroupAccountsByOrganizationIdsRequest, NewGetAccountGroupAccountsByOrganizationIdsResponse> {
        const method = this.methods[17], opt = this._transport.mergeOptions(options);
        return stackIntercept<NewGetAccountGroupAccountsByOrganizationIdsRequest, NewGetAccountGroupAccountsByOrganizationIdsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 分页获取 获取「组织」下的所有「用户」，返回「organizationID、accountID」集合
     *
     * @generated from protobuf rpc: PageListAccountGroupAccounts
     */
    pageListAccountGroupAccounts(input: PageListAccountGroupAccountsRequest, options?: RpcOptions): UnaryCall<PageListAccountGroupAccountsRequest, PageListAccountGroupAccountsResponse> {
        const method = this.methods[18], opt = this._transport.mergeOptions(options);
        return stackIntercept<PageListAccountGroupAccountsRequest, PageListAccountGroupAccountsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 批量获取指定用户组成员根据「组织列表、用户组名」
     *
     * @generated from protobuf rpc: ListAccountsByOrganizationIdsAndAccountGroupName
     */
    listAccountsByOrganizationIdsAndAccountGroupName(input: ListAccountsByOrganizationIdsAndAccountGroupNameRequest, options?: RpcOptions): UnaryCall<ListAccountsByOrganizationIdsAndAccountGroupNameRequest, ListAccountsByOrganizationIdsAndAccountGroupNameResponse> {
        const method = this.methods[19], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListAccountsByOrganizationIdsAndAccountGroupNameRequest, ListAccountsByOrganizationIdsAndAccountGroupNameResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 删除组织
     *
     * @generated from protobuf rpc: DeleteOrganization
     */
    deleteOrganization(input: DeleteOrganizationRequest, options?: RpcOptions): UnaryCall<DeleteOrganizationRequest, DeleteOrganizationResponse> {
        const method = this.methods[20], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeleteOrganizationRequest, DeleteOrganizationResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 根据组织类型获取OrganizationContext
     *
     * @generated from protobuf rpc: GetOrganizationContext
     */
    getOrganizationContext(input: GetOrganizationContextRequest, options?: RpcOptions): UnaryCall<GetOrganizationContextRequest, GetOrganizationContextResponse> {
        const method = this.methods[21], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetOrganizationContextRequest, GetOrganizationContextResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 查看accountId所在的组织（若不传accountID，则从access token中获取）
     *
     * @generated from protobuf rpc: ListOrganizationByAccountId
     */
    listOrganizationByAccountId(input: ListOrganizationByAccountIdRequest, options?: RpcOptions): UnaryCall<ListOrganizationByAccountIdRequest, ListOrganizationByAccountIdResponse> {
        const method = this.methods[22], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListOrganizationByAccountIdRequest, ListOrganizationByAccountIdResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListOrganizations
     */
    listOrganizations(input: ListOrganizationsRequest, options?: RpcOptions): UnaryCall<ListOrganizationsRequest, ListOrganizationsResponse> {
        const method = this.methods[23], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListOrganizationsRequest, ListOrganizationsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * region account group
     * 创建用户组
     *
     * @generated from protobuf rpc: CreateAccountGroup
     */
    createAccountGroup(input: CreateAccountGroupRequest, options?: RpcOptions): UnaryCall<CreateAccountGroupRequest, CreateAccountGroupResponse> {
        const method = this.methods[24], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateAccountGroupRequest, CreateAccountGroupResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateAccountGroup
     */
    updateAccountGroup(input: UpdateAccountGroupRequest, options?: RpcOptions): UnaryCall<UpdateAccountGroupRequest, UpdateAccountGroupResponse> {
        const method = this.methods[25], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateAccountGroupRequest, UpdateAccountGroupResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 获取用户组
     *
     * @generated from protobuf rpc: GetAccountGroup
     */
    getAccountGroup(input: GetAccountGroupRequest, options?: RpcOptions): UnaryCall<GetAccountGroupRequest, GetAccountGroupResponse> {
        const method = this.methods[26], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetAccountGroupRequest, GetAccountGroupResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 组织组新增用户（根据accountID）
     *
     * @generated from protobuf rpc: AddAccountToAccountGroupByAccountId
     */
    addAccountToAccountGroupByAccountId(input: AddAccountToAccountGroupByAccountIdRequest, options?: RpcOptions): UnaryCall<AddAccountToAccountGroupByAccountIdRequest, AddAccountToAccountGroupByAccountIdResponse> {
        const method = this.methods[27], opt = this._transport.mergeOptions(options);
        return stackIntercept<AddAccountToAccountGroupByAccountIdRequest, AddAccountToAccountGroupByAccountIdResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 用户自己加入用户组（用户登陆后传accessToken）
     *
     * @generated from protobuf rpc: AddAccountToAccountGroup
     */
    addAccountToAccountGroup(input: AddAccountToAccountGroupRequest, options?: RpcOptions): UnaryCall<AddAccountToAccountGroupRequest, AddAccountToAccountGroupResponse> {
        const method = this.methods[28], opt = this._transport.mergeOptions(options);
        return stackIntercept<AddAccountToAccountGroupRequest, AddAccountToAccountGroupResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 获取「用户」的「用户组」
     *
     * @generated from protobuf rpc: GetAccountGroupByAccountId
     */
    getAccountGroupByAccountId(input: GetAccountGroupByAccountIdRequest, options?: RpcOptions): UnaryCall<GetAccountGroupByAccountIdRequest, GetAccountGroupByAccountIdResponse> {
        const method = this.methods[29], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetAccountGroupByAccountIdRequest, GetAccountGroupByAccountIdResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 删除用户组
     *
     * @generated from protobuf rpc: DeletedAccountGroup
     */
    deletedAccountGroup(input: DeletedAccountGroupRequest, options?: RpcOptions): UnaryCall<DeletedAccountGroupRequest, DeletedAccountGroupResponse> {
        const method = this.methods[30], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeletedAccountGroupRequest, DeletedAccountGroupResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 获取用户组成员
     *
     * @generated from protobuf rpc: GetAccountGroupAccount
     */
    getAccountGroupAccount(input: GetAccountGroupAccountRequest, options?: RpcOptions): UnaryCall<GetAccountGroupAccountRequest, GetAccountGroupAccountResponse> {
        const method = this.methods[31], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetAccountGroupAccountRequest, GetAccountGroupAccountResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 用户组织移除用户
     *
     * @generated from protobuf rpc: RemoveAccountFromAccountGroup
     */
    removeAccountFromAccountGroup(input: RemoveAccountFromAccountGroupRequest, options?: RpcOptions): UnaryCall<RemoveAccountFromAccountGroupRequest, RemoveAccountFromAccountGroupResponse> {
        const method = this.methods[32], opt = this._transport.mergeOptions(options);
        return stackIntercept<RemoveAccountFromAccountGroupRequest, RemoveAccountFromAccountGroupResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetAccountGroupContext
     */
    getAccountGroupContext(input: GetAccountGroupContextRequest, options?: RpcOptions): UnaryCall<GetAccountGroupContextRequest, GetAccountGroupContextResponse> {
        const method = this.methods[33], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetAccountGroupContextRequest, GetAccountGroupContextResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 获取添加用户uuid
     *
     * @generated from protobuf rpc: GetUserGroupInvitationUuid
     */
    getUserGroupInvitationUuid(input: GetUserGroupInvitationUuidRequest, options?: RpcOptions): UnaryCall<GetUserGroupInvitationUuidRequest, GetUserGroupInvitationUuidResponse> {
        const method = this.methods[34], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetUserGroupInvitationUuidRequest, GetUserGroupInvitationUuidResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 用户组添加用户（uuid）
     *
     * @generated from protobuf rpc: AcceptUserInvitation
     */
    acceptUserInvitation(input: AcceptUserInvitationRequest, options?: RpcOptions): UnaryCall<AcceptUserInvitationRequest, AcceptUserInvitationResponse> {
        const method = this.methods[35], opt = this._transport.mergeOptions(options);
        return stackIntercept<AcceptUserInvitationRequest, AcceptUserInvitationResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * region permission
     *
     * @generated from protobuf rpc: GetAccountPermission
     */
    getAccountPermission(input: GetAccountPermissionRequest, options?: RpcOptions): UnaryCall<GetAccountPermissionRequest, GetAccountPermissionResponse> {
        const method = this.methods[36], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetAccountPermissionRequest, GetAccountPermissionResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 给用户组授权
     *
     * @generated from protobuf rpc: AuthorizeToAccountGroup
     */
    authorizeToAccountGroup(input: AuthorizeToAccountGroupRequest, options?: RpcOptions): UnaryCall<AuthorizeToAccountGroupRequest, AuthorizeToAccountGroupResponse> {
        const method = this.methods[37], opt = this._transport.mergeOptions(options);
        return stackIntercept<AuthorizeToAccountGroupRequest, AuthorizeToAccountGroupResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 获取用户组权限
     *
     * @generated from protobuf rpc: ListAccountGroupPermission
     */
    listAccountGroupPermission(input: ListAccountGroupPermissionRequest, options?: RpcOptions): UnaryCall<ListAccountGroupPermissionRequest, ListAccountGroupPermissionResponse> {
        const method = this.methods[38], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListAccountGroupPermissionRequest, ListAccountGroupPermissionResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 获取组织用户组权限UUIDs（鉴权用）
     *
     * @generated from protobuf rpc: ListAccountGroupPermissionUUID
     */
    listAccountGroupPermissionUUID(input: ListAccountGroupPermissionUUIDRequest, options?: RpcOptions): UnaryCall<ListAccountGroupPermissionUUIDRequest, ListAccountGroupPermissionUUIDResponse> {
        const method = this.methods[39], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListAccountGroupPermissionUUIDRequest, ListAccountGroupPermissionUUIDResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 删除组织用户组权限
     *
     * @generated from protobuf rpc: DeleteAccountGroupPermission
     */
    deleteAccountGroupPermission(input: DeleteAccountGroupPermissionRequest, options?: RpcOptions): UnaryCall<DeleteAccountGroupPermissionRequest, DeleteAccountGroupPermissionResponse> {
        const method = this.methods[40], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeleteAccountGroupPermissionRequest, DeleteAccountGroupPermissionResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 根据用户组id获取权限uuid集合
     *
     * @generated from protobuf rpc: GetAccountGroupPermissionUUIDs
     */
    getAccountGroupPermissionUUIDs(input: GetAccountGroupPermissionUUIDsRequest, options?: RpcOptions): UnaryCall<GetAccountGroupPermissionUUIDsRequest, GetAccountGroupPermissionUUIDsResponse> {
        const method = this.methods[41], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetAccountGroupPermissionUUIDsRequest, GetAccountGroupPermissionUUIDsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * region organization relationship
     * 创建组织关系
     *
     * @generated from protobuf rpc: CreateOrganizationRelationship
     */
    createOrganizationRelationship(input: CreateOrganizationRelationshipRequest, options?: RpcOptions): UnaryCall<CreateOrganizationRelationshipRequest, CreateOrganizationRelationshipResponse> {
        const method = this.methods[42], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateOrganizationRelationshipRequest, CreateOrganizationRelationshipResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 删除组织关系
     *
     * @generated from protobuf rpc: DeleteOrganizationRelationship
     */
    deleteOrganizationRelationship(input: DeleteOrganizationRelationshipRequest, options?: RpcOptions): UnaryCall<DeleteOrganizationRelationshipRequest, DeleteOrganizationRelationshipResponse> {
        const method = this.methods[43], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeleteOrganizationRelationshipRequest, DeleteOrganizationRelationshipResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 切换默认组织关系
     *
     * @generated from protobuf rpc: AlterDefaultOrganizationRelationship
     */
    alterDefaultOrganizationRelationship(input: AlterDefaultOrganizationRelationshipRequest, options?: RpcOptions): UnaryCall<AlterDefaultOrganizationRelationshipRequest, AlterDefaultOrganizationRelationshipResponse> {
        const method = this.methods[44], opt = this._transport.mergeOptions(options);
        return stackIntercept<AlterDefaultOrganizationRelationshipRequest, AlterDefaultOrganizationRelationshipResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 通过id获取组织关系
     *
     * @generated from protobuf rpc: GetOrganizationRelationshipById
     */
    getOrganizationRelationshipById(input: GetOrganizationRelationshipByIdRequest, options?: RpcOptions): UnaryCall<GetOrganizationRelationshipByIdRequest, GetOrganizationRelationshipByIdResponse> {
        const method = this.methods[45], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetOrganizationRelationshipByIdRequest, GetOrganizationRelationshipByIdResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 通过organizationId获取组织关系列表
     *
     * @generated from protobuf rpc: GetOrganizationRelationshipListByOrganizationId
     */
    getOrganizationRelationshipListByOrganizationId(input: GetOrganizationRelationshipListByOrganizationIdRequest, options?: RpcOptions): UnaryCall<GetOrganizationRelationshipListByOrganizationIdRequest, GetOrganizationRelationshipListByOrganizationIdResponse> {
        const method = this.methods[46], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetOrganizationRelationshipListByOrganizationIdRequest, GetOrganizationRelationshipListByOrganizationIdResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 通过organizationId获取默认组织关系
     *
     * @generated from protobuf rpc: GetDefaultOrganizationRelationship
     */
    getDefaultOrganizationRelationship(input: GetDefaultOrganizationRelationshipRequest, options?: RpcOptions): UnaryCall<GetDefaultOrganizationRelationshipRequest, GetDefaultOrganizationRelationshipResponse> {
        const method = this.methods[47], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetDefaultOrganizationRelationshipRequest, GetDefaultOrganizationRelationshipResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 获取上传组织logo的预签名链接
     *
     * @generated from protobuf rpc: GetPresignedPutObjectUrl
     */
    getPresignedPutObjectUrl(input: GetPresignedPutObjectUrlRequest, options?: RpcOptions): UnaryCall<GetPresignedPutObjectUrlRequest, GetPresignedPutObjectUrlResponse> {
        const method = this.methods[48], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetPresignedPutObjectUrlRequest, GetPresignedPutObjectUrlResponse>("unary", this._transport, method, opt, input);
    }
}
